import { render, staticRenderFns } from "./benefits-rich-text.vue?vue&type=template&id=25f481f6"
import script from "./benefits-rich-text.vue?vue&type=script&lang=js"
export * from "./benefits-rich-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports